import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PetUpdateType } from 'angular-to-phaser';
import { NestableAuthenticatedView } from 'src/app/components/base.component';
import { MainpageComponent } from 'src/app/components/mainpage/mainpage.component';
import { GameStateResponse, PetDTO, PetResult } from 'src/app/dto';
import { AuthService } from 'src/app/services/auth.service';
import { PetService } from 'src/app/services/pet.service';
import { UIStateService } from 'src/app/services/ui-state.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-critter-state-update',
    templateUrl: './critter-state-update.component.html',
    styleUrls: ['./critter-state-update.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CritterStateUpdateComponent extends NestableAuthenticatedView implements OnInit, AfterViewInit {

    @Input() stateUpdate: GameStateResponse;
    // An array (not a Map) so the template can @for over a stable, identity-trackable
    // collection - Map.entries() hands back a new tuple on every change-detection check,
    // which defeats tracking and forces Angular to destroy/recreate the whole row each check.
    petUpdates: { pet: PetDTO; updates: PetResult[] }[] = [];

    constructor(private userService: UserService, private petService: PetService, private modalService: NgbModal, route: ActivatedRoute, router: Router, authService: AuthService, uiStateService: UIStateService) {
        super(router, route, null, authService, MainpageComponent.route, uiStateService);
    }


    ngOnInit(): void {
        this.initPetUpdates();
    }

    ngAfterViewInit(): void {
        this.initPetUpdates();
    }

    private initPetUpdates() {
        if (this.stateUpdate?.PetChanges && this.petUpdates.length === 0) {
            let petMap = this.petService.activeUserPetsSignal();
            this.stateUpdate?.PetChanges?.forEach(petResult => {

                var pet = petMap.find(p => p.Id === petResult.PetId);
                if (!pet) {
                    // Can happen if activeUserPets hasn't caught up with a pet acquired earlier
                    // in the same session (see PetService.createPet). Skip this pet's row rather
                    // than letting the whole modal fail to render.
                    console.warn(`CritterStateUpdateComponent: pet ${petResult.PetId} not found in activeUserPets cache, skipping its update row`);
                    return;
                }
                if (petResult.ChangedStat == PetUpdateType.Mood) {
                    pet.UpdateMood(petResult.FinalState, petResult.FinalStateMoodImagePath);
                }
                const existingRow = this.petUpdates.find(row => row.pet === pet);
                if (existingRow) {
                    existingRow.updates.push(petResult);
                } else {
                    this.petUpdates.push({ pet, updates: [petResult] });
                }
            });
        }
    }

    public startAnimation() {
        (<any>document.querySelector(`#${this.stateUpdate.LottieId}`)).play();
    };
}
